const { makeStyles } = require('@material-ui/core');

export const timecardWorkdayStyles = makeStyles((theme) => ({
  headerContainer: {
    top: '200px',
    height: '60px',
    position: 'sticky',
    // background: theme.palette.background.paper,
    background: '#E9F1FD',
    display: 'flex',
    borderRadius: '10px',
    boxShadow: '1px 5px 5px rgba(0,0,0,.1)',
    marginBottom: '8px',
    border: '1px solid lightgray',
    [theme.breakpoints.down('xs')]: {
      top: 'inherit',
    },
  },
  headerContainerLate: {
    top: '200px',
    height: '60px',
    position: 'sticky',
    background: theme.palette.error.main,
    color: 'white',
    display: 'flex',
    borderRadius: '10px',
    boxShadow: '1px 5px 5px rgba(0,0,0,.1)',
    marginBottom: '8px',
    border: '1px solid lightgray',
  },
  headerContainerSmall: {
    top: '200px',
    height: '30px',
    position: 'sticky',
    background: '#E9F1FD',
    display: 'flex',
    borderRadius: '10px',
    boxShadow: '1px 5px 5px rgba(0,0,0,.1)',
    marginBottom: '8px',
    border: '1px solid lightgray',
    [theme.breakpoints.down('xs')]: {
      top: 'inherit',
    },
  },
  headerContent: {
    margin: 'auto 0px',
  },
  dayText: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  textField: {
    marginRight: '10px',
  },
  readOnlyData: {
    display: 'flex',
  },
  procedureList: {
    marginTop: '10px',
    border: '1px solid lightgray',
    borderRadius: '10px',
    boxShadow: '1px 5px 5px rgba(0,0,0,.1)',
    '& .header p': {
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    overflow: 'hidden',
  },
}));
